import React from "react";
import { useTranslation } from "react-i18next";
import "./ListCard.css";

export default function ListCard({ icon, titleKey, descriptionKey }) {

    const { t } = useTranslation();

    return (
        <article className="list-card">
            {icon && (
                <div className="list-card__icon">
                    <img src={icon} alt={t(titleKey)} />
                </div>
            )}

            <div className="list-card__content">
                <h3 className="list-card__title">{t(titleKey)}</h3>
                <p className="list-card__desc">{t(descriptionKey)}</p>
            </div>
        </article>
    );
}
